import { POOL_STATUS } from "utils/constants.ts";

export const isPoolClosed = (poolStatus: number) => [POOL_STATUS.LIVE, POOL_STATUS.CALCULATING, POOL_STATUS.SETTLED].includes(poolStatus);
